<template>
    <!-- <transition name="fade-delay"> -->
        <router-link :to="$onduro.route('chats', channel.id)" v-show="ready">
            <div class="profile"><gravatar :email="gravatar" @loaded="ready = true" /></div>
            <div class="channel-list-details" :class="{ 'unread': unreadCount > 0 }">
                <time v-if=" ! empty(lastChannel.lastChat)" :datetime="lastChannel.lastChat.createdAt">{{ dateFormat('YYYY-MM-DD HH:mm:ss', lastChannel.lastChat.createdAt) }}</time>
                <time v-else :datetime="channel.createdAt">{{ dateFormat('YYYY-MM-DD HH:mm:ss', channel.createdAt) }}</time>

                <chat-bubble class="bubble--blue" :count="unreadCount" limit="99" />

                <b>{{ channel.title }}</b><br>
                <small class="text-light" v-if=" ! empty(lastChannel.lastChat)">
                    <b v-if="lastChannel.lastChat.mine">{{ $t('text.you') }}: </b>
                    {{ lastChannel.lastChat.message }}
                </small>
            </div>
        </router-link>
    <!-- </transition> -->
</template>

<script>
import lodash from '../../helpers/lodash'
import channelChat from '../../helpers/channelChat'

export default
{
    name: 'ChannelListSingle',

    mixins: [lodash, channelChat],

    computed:
    {
        gravatar()
        {
            return _.filter(this.channel.participantsWithTrashed, item =>
            {
                return item.user.id !== this.user.id
            })[0].user.gravatar;
        }
    }
}
</script>



// WEBPACK FOOTER //
// ChannelListSingle.vue?37cfdc60